import { ActionTracker } from "@dpdgroupuk/react-event-tracker";

const { REACT_APP_APP_ENGINE } = process.env;

export default new ActionTracker({
  projectRef: "PickupFinder",
  debug: false,
  url: `${REACT_APP_APP_ENGINE}/analytics`,
});
